import React from 'react';

import { Steps } from './style';

const { Step } = Steps;

const Stepper = ({
  currentStep = 0,
  steps = [],
  direction = 'horizontal',
  size = 'small',
  type="inline",
  onChange = () => {},
  status = 'process',
}) => {
  
  return (
    <Steps
      current={currentStep}
      direction={direction}
      size={size}
      type={type}
      onChange={onChange}
      status={status}
    >
      {steps.map((step, index) => (
        <Step
          key={index}
          title={step.title}
          description={step.description}
        />
      ))}
    </Steps>
  );
};

export default Stepper;
